var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 5H40H31V8L37.8788 8L28.4352 17.4436L30.5565 19.5649L40 10.1214V17H43V8V5ZM8 43H5V40V31H8V37.8786L17.4435 28.4351L19.5648 30.5564L10.1212 40H17V43H8ZM40 43H43V40V31H40V37.8786L30.5565 28.4351L28.4352 30.5564L37.8788 40H31V43H40ZM8 5H5V8V17H8V10.1214L17.4435 19.5649L19.5648 17.4436L10.1212 8L17 8V5H8Z",
  fill: "currentColor"
})));
export { SvgExpandIcon as ReactComponent };
export default new URL("/home/runner/_work/motorway-dealer-webapp/motorway-dealer-webapp/public/static/images/expand-icon.svg", import.meta.url).toString();